module.exports = __webpack_public_path__ + "static/media/styledChevromRight.3c1bcd79.svg";